var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#171717",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1655_17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 3.05176e-05C7.45959 3.05176e-05 5.4001 2.05952 5.4001 4.60003V5H2.6001C2.28888 5 2.02932 5.23797 2.00236 5.54802L1.08582 16.0882C0.902925 18.1915 2.561 20 4.67229 20H15.3278C17.4391 20 19.0971 18.1915 18.9143 16.0882L17.9978 5.54803C17.9709 5.23797 17.7113 5 17.4001 5H14.6001V4.60003C14.6001 2.05952 12.5406 3.05176e-05 10.0001 3.05176e-05ZM13.4001 6.2V9.39999C13.4001 9.73137 13.6687 9.99999 14.0001 9.99999C14.3315 9.99999 14.6001 9.73137 14.6001 9.39999V6.2H16.85L17.7188 16.1921C17.8407 17.5944 16.7353 18.8 15.3278 18.8H4.67229C3.26476 18.8 2.15938 17.5944 2.28131 16.1921L3.15019 6.2H5.4001V9.39999C5.4001 9.73137 5.66873 9.99999 6.0001 9.99999C6.33147 9.99999 6.6001 9.73137 6.6001 9.39999V6.2H13.4001ZM13.4001 5V4.60003C13.4001 2.72226 11.8779 1.20003 10.0001 1.20003C8.12233 1.20003 6.6001 2.72226 6.6001 4.60003V5H13.4001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1655_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.03682993294341725b85e9dde601fe7f.svg";
export { ForwardRef as ReactComponent };